 
 
   import React, { useEffect, useState } from 'react';
   import { getMedia } from '../Service/Api';
   import Slider from "react-slick";
   import {Link} from 'react-router-dom'
   import LazyLoad from 'react-lazyload';
   
   const Youtube = () => {
    const [data, setData] = useState([]);  

   useEffect(() => {
      const fetchData = async () => {
         try {
            const topperData = await getMedia(); 
            const filterDataCode = topperData.filter((item)=>item.category === "YoutubeSocial");
            setData(filterDataCode)
         }
         catch{

         }
        }
      fetchData();
   }, []);
 
   const emptyArray = [
    { title: 'YouTube Title', attachments: 'https://webapi.entab.info/api/image/NCSR/public/Images/social-bg.jpg' },
    { title: 'YouTube Title', attachments: 'https://webapi.entab.info/api/image/NCSR/public/Images/social-bg.jpg' },
  ];

     const settings = {
       autoplay: true,
       infinite: true,
       autoplaySpeed: 3000,
       speed: 800,
       slidesToShow: 1,
       slidesToScroll: 1,
       initialSlide: 0,
       arrows: false,
       adaptiveHeight: true,
        
     };
   
     return (
       <Slider {...settings} className="socialslider">
         {data.length > 0 ? (
           data.map((item, index) => (
             <div className="item" key={index}>
               <div className="socialDiv">
               <Link to={item.url} target="_blank">
                   <LazyLoad>
                     <img
                       src={`https://webapi.entab.info/api/image/${item.attachments}`}
                       className="img-fluid tooperpicicn"
                       alt="Social Media"
                     />
                   </LazyLoad>
                   <h5>{item.title}</h5>
                   </Link>
                
               </div>
             </div>
           ))
         ) : (
           emptyArray.map((item, index) => (
             <div className="item" key={index}>
               <div className="socialDiv">
                  <Link to="https://www.youtube.com/@NIRMALACONVENTSCHOOLRAJKOT" target="_blank">
                   <LazyLoad>
                     <img
                       src="https://webapi.entab.info/api/image/NCSR/public/Images/social-bg.jpg"
                       className="img-fluid tooperpicicn"
                       alt="Social Media"
                     />
                   </LazyLoad>
                   <h5>{item.title}</h5>
                   </Link>
                 </div>
                  
               </div> 
           ))
         )}
       </Slider>
     );
   };
     
export default Youtube;
